// Constante pour choisir le système de récupération des projets
// 'legacy' = système simple-viewer (ancien)
// 'new' = système avec token UUID (nouveau)
export const PROJECT_SYSTEM_TYPE = 'new';

// Système legacy (simple-viewer) - récupération simple par ID
const GetProjectDataLegacy = id => fetch(process.env.REACT_APP_U1_VIEWERSVC_API+'project/'+id);

// Nouveau système - avec support token UUID et credentials
const GetProjectDataNew = (id, uuidToken = null) => {
    let url;
    
    if (uuidToken) {
        // Use API endpoint with token query parameter
        url = `${process.env.REACT_APP_U1_VIEWERSVC_API}project/by-token?token=${uuidToken}`;
    } else {
        // Legacy base64 project reference
        url = `${process.env.REACT_APP_U1_VIEWERSVC_API}project/${id}`;
    }
    
    return fetch(url, {
        credentials: 'include',
        headers: {
            'Accept': 'application/json'
        }
    });
};

// Fonction exportée qui switch entre les deux systèmes selon la constante
export const GetProjectData = (id, uuidToken = null) => {
    if (PROJECT_SYSTEM_TYPE === 'legacy') {
        return GetProjectDataLegacy(id);
    } else {
        return GetProjectDataNew(id, uuidToken);
    }
};
export const GetProjectFile = hash => fetch(process.env.REACT_APP_U1_VIEWERSVC_API+'reference/'+hash)
export const PutProjectStatus = (id, status) => fetch(process.env.REACT_APP_U1_VIEWERSVC_API+'project/'+id+'/'+status)
export let PostReferencePhoto = (hash, data) => fetch(process.env.REACT_APP_U1_VIEWERSVC_API+'reference/'+hash+'/photo', {
    method: "POST", 
    headers: {
      'Content-Type': 'text/plain'
    },
    body: data
});
